import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import exportAccessorials from "@tKgpco/Handlers/Accessorials/ExportAccessorials";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { AccessorialsFormValues } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";
import React, { useContext, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    exportAccessorials,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    selectedAccessorialIds: state.KGPState.customAccessorials.selectedAccessorialIds,
    selectFilter: state.KGPState.customAccessorials.selectFilter,
    selectFilterText: state.KGPState.customAccessorials.selectFilterText,
    isAllAccessorialSelected: state.KGPState.customAccessorials.isAllAccessorialSelected,
});

interface CustomWidgetStyles {
    wrapper?: InjectableCss;
}

const styles: CustomWidgetStyles = {};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ExportAccessorials: React.FC<Props> = ({ 
    id,
    exportAccessorials,
    selectedAccessorialIds,
    selectFilter,
    selectFilterText,
    isAllAccessorialSelected }) => {
    const [isExporting, setIsExporting] = useState(false);
    const toasterContext = useContext(ToasterContext);

    const handleExport = () => {
        if (isExporting) {
            return;
        }

        const accessorialsIds = Object.keys(selectedAccessorialIds);
        const AccessoriaIds:string[]=[];
        accessorialsIds.forEach((id) => {
            AccessoriaIds.push(id)
        });
        let filters= {}
        if(isAllAccessorialSelected) {
            filters = { [selectFilter as keyof AccessorialsFormValues]: selectFilterText }
        } else {
            filters = { [selectFilter as keyof AccessorialsFormValues]: selectFilterText, AccessoriaIds}
        }

        exportAccessorials({ queryParams: filters, onSuccess: onUploadingSuccess });
    };

    const onUploadingSuccess = () => {
        setIsExporting(false);
        toasterContext.addToast({ body: translate("Accessorials exported successfully"), messageType: "success" });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Clickable onClick={handleExport} title="Export Accessorials">
                <Icon src="Download" size={20} />
            </Clickable>
        </StyledWrapper>
    );
};

const importAccessorialsWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ExportAccessorials),
    definition: {
        group: "Basic",
    },
};

export default importAccessorialsWidget;
